import React from "react";
import Gambit from "../Gambit";
import { styleClassName } from "../styleHelper";
import {
  SelectionConfirmButtonProps,
  SelectionInputProps,
  SelectionPickProps,
  SelectionTabsProps
} from "./types";

export function SelectionTabs({ tabs, tab, setTab }: SelectionTabsProps) {
  const getClassName = (key: string) =>
    key === tab ? "nes-btn is-primary" : "nes-btn";
  return (
    <div id="selection-tabs">
      {tabs.map(tabKey => (
        <button
          type="button"
          key={tabKey}
          className={getClassName(tabKey)}
          onClick={() => setTab(tabKey)}
        >
          {tabKey}
        </button>
      ))}
    </div>
  );
}

export function SelectionPick({ gambit }: SelectionPickProps) {
  return (
    <div className="selection-pick">
      <span>Current Gambit: </span>
      {gambit === undefined ? "(none)" : <Gambit gambit={gambit} />}
    </div>
  );
}

export function SelectionInput({ text, onChange }: SelectionInputProps) {
  const inputClassName = styleClassName("nes-input");
  return (
    <div className="nes-field">
      <label htmlFor="name_field">
        Filter
        <input
          type="text"
          id="name_field"
          className={inputClassName}
          onChange={onChange}
          value={text}
        />
      </label>
    </div>
  );
}

export function ConfirmButton({
  isReady = false,
  clickHandler
}: SelectionConfirmButtonProps) {
  const className = `nes-btn is-primary ${isReady ? "" : "is-disabled"}`;
  return (
    <button type="submit" className={className} onClick={clickHandler}>
      Confirm
    </button>
  );
}
